import { Dispatch, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import InfoIcon from '@images/svg-icons/infoIcon.svg';
import ArrowDown16 from '@images/svg-icons/arrowDown16.svg';
import CheckPrescription from '@images/svg-icons/check-prescription.svg';
import PlaceHolderCL from '@images/svg-icons/placeholderImageCL.svg';
import PlaceHolderFrame from '@images/svg-icons/placeholderImageFrame.svg';
import PlaceHolderOther from '@images/svg-icons/placeholderImageOther.svg';
import lensImage from '@images/lens.png';
import BoxImage from './BoxImage';
import Modal from '@components/styled-UI/Modal';

import {
    IRetailOrderItems,
    OnlineOrderDetailsSkuDetails,
    OnlineOrderItemType,
    OrderDetailsContactLenses,
} from '@interfaces/myPurchasesInterfaces';

import * as actions from '@redux-actions/';

import { getOrderItemCarrierUrl, getPrescriptionInfo, getTrackThisItemInfo } from '@services/myPurchasesServices';

import { mapContactLensesAttributes } from '@utils/pages-utils/MyPurchasesUtils';

import { getProductDetails, getLabelFallback, getMockedFile, isCLAttributePresent, isCLPosAttributePresent } from '@utils/utils';
import URLS from '@utils/urlList';

import { v4 as uuidv4 } from 'uuid';

import axios, { AxiosRequestConfig } from 'axios';
import PrescriptionModal from './PrescriptionModal';
import { forEach } from 'lodash';
import { getStringFromDate } from '@utils/dateUtils';
import { getCookie } from '@utils/cookie';
import { getPersonalDetails } from '@services/myProfileServices';

interface Props {
    orderItem: IRetailOrderItems;
    orderId: string;
    storeNumber: string;
    prescriptionInfo: any;
    onlyOneIsNotBuyable: boolean;
    isTrackItem: boolean;
    hasPrescriptionId: string;
}


// const renderAlertInfoPrescriptionNeeded = (
//     dispatch: Dispatch<any>,
//     config: any,
//     orderId: string,
//     orderAddressEmail: string,
//     goToProvidePrescriptionSection: Function
// ): JSX.Element => {
//     return (
//         <div className="alert-info">
//             <div className="left">
//                 <div className="info-icon">
//                     <InfoIcon />
//                 </div>
//                 <div className="info-message">
//                     <div className={'primary-message medium bold align-left dark-info'}>
//                         {getLabelFallback(
//                             'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_TITLE'
//                         )}
//                     </div>
//                     <div className={'secondary-message small align-left dark-info'}>
//                         {getLabelFallback(
//                             'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_SUBTITLE'
//                         )}
//                         <a
//                             data-element-id="OrderDetails_OEE"
//                             data-description="Schedule"
//                             href="#"
//                             className="secondary-message small dark-info bold schedule"
//                             onClick={() =>
//                                 window.open(
//                                     config.callFromComponentToTO.myPurchases.orderDetail
//                                         .scheduleEyeExam,
//                                     '_parent'
//                                 )
//                             }
//                         >
//                             {getLabelFallback(
//                                 'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_MESSAGE_PLACEHOLDER'
//                             )}
//                         </a>
//                     </div>
//                 </div>
//             </div>
//             <button
//                 className="primary-button button-size-small"
//                 data-element-id="OrderDetails_UploadPrescription"
//                 data-description="Submit"
//                 onClick={() => {
//                     /*dispatch(
//                         getEncryptedOnlineOrderId({
//                             isMockRequest:
//                                 config.mockRequest,
//                             storeId: config.storeId,
//                             orderId: Number(obj.orderId),
//                         })
//                     )*/
//                     goToProvidePrescriptionSection(orderId, orderAddressEmail);
//                 }}
//             >
//                 {getLabelFallback(
//                     'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ALERT_INFO_SUBMIT_NOW_CTA_LABEL'
//                 )}
//             </button>
//         </div>
//     );
// };

const renderLenses = (orderItemLensesInfo: IRetailOrderItems) => {
    return (
        <>
            {!!orderItemLensesInfo.lensBrand && (
                <span
                    className="secondary-message medium align-left dark-grey"
                >
                    {orderItemLensesInfo.lensBrand}
                </span>
            )}
            {!!orderItemLensesInfo.lensBundle && (
                <span
                    className="secondary-message medium align-left dark-grey"
                >
                    {orderItemLensesInfo.lensBundle}
                </span>
            )}
            {!!orderItemLensesInfo.lensType && (
                <span
                    className="secondary-message medium align-left dark-grey"
                >
                    {orderItemLensesInfo.lensType}
                </span>
            )}
            {!!orderItemLensesInfo.color && (
                <span
                    className="secondary-message medium align-left dark-grey"
                >
                    {orderItemLensesInfo.color}
                </span>
            )}
            {!!orderItemLensesInfo.thickness && (
                <span
                    className="secondary-message medium align-left dark-grey"
                >
                    {orderItemLensesInfo.thickness}
                </span>
            )}
            {!!orderItemLensesInfo.visionNeed && (
                <span
                    className="secondary-message medium align-left dark-grey"
                >
                    {orderItemLensesInfo.visionNeed}
                </span>
            )}
            {!!orderItemLensesInfo.finishings && (
                <>
                    {orderItemLensesInfo.finishings.map((element) => (
                        <span
                            className="secondary-message medium align-left dark-grey"
                        >
                            {element}
                        </span>
                    ))}
                </>
            )}
        </>
    )
};

const renderGlassesBody = (orderItem: IRetailOrderItems, isMobile: boolean, frameSize: string): JSX.Element => {
    const [openLenses, setOpenLenses] = useState(false);

    return (
        <div className="glasses">
            <div className="glasses-header retail">
                <div className="glasses-header-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_LABEL'
                        )}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.frameName}</div>
                </div>
                {!!orderItem.frameColor && (
                    <div className="glasses-header-row">
                        <div className="secondary-message align-left bold medium">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_COLOR_LABEL'
                            )}
                        </div>
                        <div className="secondary-message align-left medium margin-left">{orderItem.frameColor.charAt(0).toUpperCase() + orderItem.frameColor.slice(1)}</div>
                    </div>
                )}
                <div className="glasses-header-row">
                    <div className="secondary-message align-left bold medium">
                        {!isMobile ? getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_SIZE_LABEL'
                        ) : getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_SIZE_LABEL_MOBILE_RETAIL'
                        )}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{frameSize}</div>
                </div>
            </div>
            {orderItem.lensBrand?.length > 0 && (
                <div className="glasses-body retail">
                    <div
                        className={`secondary-message align-left bold ${(isMobile ? 'small' : 'medium') +
                            (openLenses ? ' arrow-top' : ' arrow-down')
                            } `}
                        onClick={() => setOpenLenses(!openLenses)}
                    >
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENSES_LABEL'
                        )}
                        <ArrowDown16 />
                    </div>
                    <div className={'lenses-container' + (openLenses ? ' show' : '')}>
                        {renderLenses(orderItem)}
                    </div>
                </div>
            )}
            {orderItem.hasWarranty && (
                <div className="glasses-warranty">
                    <div className='glasses-warranty-row'>
                        <div className="secondary-message glasses-warranty-text align-left bold medium">
                            {getLabelFallback(
                                'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FRAME_WARRANTY'
                            )}
                        </div>
                        <div className="glasses-warranty-date secondary-message medium small-mob">{`(Valid until ${getStringFromDate(new Date(orderItem.validUntil), 'MM/dd/yyyy')})`}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

const renderLensesBody = (orderItem: IRetailOrderItems, isMobile: boolean): JSX.Element => {
    return (
        <div className="lenses">
            <div className="lenses-header">
                <div className="lenses-header-row">
                    <div className="secondary-message align-left bold medium">
                        {orderItem.lensName}
                    </div>
                    <div className="secondary-message align-left medium margin-left gray">{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_ONLY')}</div>
                </div>
            </div>
            <div className="lenses-body">
                <div className="lenses-body-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_VISION_NEED')}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.visionNeed}</div>
                </div>
                <div className="lenses-body-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_BRAND')}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.lensBrand}</div>
                </div>
                <div className="lenses-body-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_TYPE')}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.lensType}</div>
                </div>
                <div className="lenses-body-row">
                    <div className="secondary-message align-left bold medium">
                        {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_LENS_THICKNESS')}
                    </div>
                    <div className="secondary-message align-left medium margin-left">{orderItem.thickness}</div>
                </div>
                <div className="lenses-body-row">
                    {orderItem.finishings.length > 0 && (
                        <>
                            <div className="secondary-message align-left bold medium">
                                {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_FINISHINGS')}
                            </div>
                            {orderItem.finishings.map(
                                (orderItemFinishingValue) =>
                                    renderFinishings(orderItemFinishingValue))}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const renderFinishings = (finishings: string): JSX.Element => {
    return (
        <div className="secondary-message align-left medium margin-left">{finishings}</div>
    )
}

const renderOthersBody = (orderItem: IRetailOrderItems, isMobile: boolean): JSX.Element => {
    return (
        <div className="others">
            <div className="others-header">
                <div className="others-header-row">
                    <div className="secondary-message align-left bold medium uppercase">
                        {orderItem.subCategory}
                    </div>
                    <div className="secondary-message align-left medium margin-left gray uppercase">{orderItem.brandDescription}</div>
                </div>
            </div>
            <div className="others-body">
                <div className="others-body-row">
                    <div className="secondary-message align-left medium margin-left others">{orderItem.description.charAt(0).toUpperCase() + orderItem.description.slice(1).toLowerCase()}</div>
                </div>
            </div>
        </div>
    );
};

const renderContactBody = (
    orderItem: IRetailOrderItems,
    isMobile: boolean
): JSX.Element => {
    return (
        <div className="contact">
            <div className="contact-header secondary-message align-left medium">
                {orderItem.styleName}
                <span className="contact-brand">{orderItem.brandName}</span>
            </div>
            {!!orderItem.dataPrescription && !isMobile && (
                <>
                    <div className="contact-body retail">
                        {renderDeskopTable(orderItem, orderItem.dataPrescription)}
                    </div>
                </>
            )}
            {!!orderItem.dataPrescription && isMobile && (
                <>
                    <div className="contact-body retail">
                        {renderMobileTable(orderItem, orderItem.dataPrescription)}
                    </div>
                </>
            )}
        </div>
    );
};


const renderDesktopTableBody = (
    eyeCode: string,
    dataPrescription: any,
): JSX.Element => {
    return (
        <>
            {eyeCode.includes('RIGHT') && (
                <tbody key={uuidv4()}>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_RIGHT_LABEL')}
                        </td>
                        {(!!dataPrescription.rightPower) && (
                            <td className="secondary-message medium align-left">
                                {dataPrescription.rightPower}
                            </td>
                        )}
                        {(!!dataPrescription.rightBc) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightBc}
                            </td>
                        )}
                        {(!!dataPrescription.rightDia) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightDia}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.rightCyl) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightCyl}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.rightAxis) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightAxis}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.rightColor) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightColor}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.rightAdd) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightAdd}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.rightDominance) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.rightDominance === 'true' ? 'D' : 'N'}
                            </td>
                        )}
                    </tr>
                </tbody>
            )}

            {eyeCode.includes('LEFT') && (
                <tbody key={uuidv4()}>
                    <tr>
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_LEFT_LABEL')}
                        </td>
                        {(!!dataPrescription.leftPower) && (
                            <td className="secondary-message medium align-left">
                                {dataPrescription.leftPower}
                            </td>
                        )}
                        {(!!dataPrescription.leftBc) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftBc}
                            </td>
                        )}
                        {(!!dataPrescription.leftDia) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftDia}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.leftCyl) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftCyl}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.leftAxis) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftAxis}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.leftColor) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftColor}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.leftAdd) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftAdd}
                            </td>
                        )}
                        {isCLPosAttributePresent(dataPrescription.leftDominance) && (
                            <td className="secondary-message medium align-center">
                                {dataPrescription.leftDominance === 'true' ? 'D' : 'N'}
                            </td>
                        )}
                    </tr>
                </tbody>
            )}
        </>
    );
};

const renderDeskopTable = (
    orderItem: IRetailOrderItems,
    dataPrescription: any,
): JSX.Element => {
    return (
        <div className="contact-table-order-detail retail">
            <table>
                <thead>
                    <tr>
                        <th>
                        </th>
                        {(!!dataPrescription.rightPower || !!dataPrescription.leftPower) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL'
                                )}
                            </th>
                        )}
                        {(!!dataPrescription.rightBc || !!dataPrescription.leftBc) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL'
                                )}
                            </th>
                        )}
                        {(!!dataPrescription.rightDia || !!dataPrescription.leftDia) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLPosAttributePresent(dataPrescription.rightCyl) || isCLPosAttributePresent(dataPrescription.leftCyl)) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLPosAttributePresent(dataPrescription.rightAxis) || isCLPosAttributePresent(dataPrescription.leftAxis)) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLPosAttributePresent(dataPrescription.rightColor) || isCLPosAttributePresent(dataPrescription.leftColor)) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLPosAttributePresent(dataPrescription.rightAdd) || isCLPosAttributePresent(dataPrescription.leftAdd)) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL'
                                )}
                            </th>
                        )}
                        {(isCLPosAttributePresent(dataPrescription.rightDominance) || isCLPosAttributePresent(dataPrescription.leftDominance)) && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DOMINANCE_LABEL'
                                )}
                            </th>
                        )}
                    </tr>
                </thead>

                {renderDesktopTableBody(orderItem.eyeCode, dataPrescription)}
            </table>
            <table>
                <thead>
                    <tr>
                        <th className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL'
                            )}
                        </th>
                    </tr>
                </thead>
                {orderItem.eyeCode.includes('RIGHT') && (
                    <tbody key={uuidv4()}>
                        <tr>
                            <td className="secondary-message medium align-left quantity">
                                {orderItem.quantityRight}
                            </td>
                        </tr>
                    </tbody>
                )}
                {orderItem.eyeCode.includes('LEFT') && (
                    <tbody key={uuidv4()}>
                        <tr>
                            <td className="secondary-message medium align-left quantity">
                                {orderItem.quantityLeft}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
};

const renderMobileTableBody = (
    eyeCode: string,
    dataPrescription: any,
): JSX.Element => {
    return (
        <>
            <tbody key={uuidv4()}>
                <tr>
                    {(!!dataPrescription.rightPower || !!dataPrescription.leftPower) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_POWER_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && !!dataPrescription.rightPower && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightPower}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && !!dataPrescription.leftPower && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftPower}
                        </td>
                    )}
                </tr>
                <tr>
                    {(!!dataPrescription.rightBc || !!dataPrescription.leftBc) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BC_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && !!dataPrescription.rightBc && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightBc}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && !!dataPrescription.leftBc && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftBc}
                        </td>
                    )}
                </tr>
                <tr>
                    {(!!dataPrescription.rightDia || !!dataPrescription.leftDia) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DIA_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && !!dataPrescription.rightDia && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightDia}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && !!dataPrescription.leftDia && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftDia}
                        </td>
                    )}
                </tr>
                <tr>
                    {(isCLPosAttributePresent(dataPrescription.rightCyl) || isCLPosAttributePresent(dataPrescription.leftCyl)) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_CYL_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && isCLPosAttributePresent(dataPrescription.rightCyl) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightCyl}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && isCLPosAttributePresent(dataPrescription.leftCyl) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftCyl}
                        </td>
                    )}
                </tr>
                <tr>
                    {(isCLPosAttributePresent(dataPrescription.rightAxis) || isCLPosAttributePresent(dataPrescription.leftAxis)) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_AXIS_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && isCLPosAttributePresent(dataPrescription.rightAxis) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightAxis}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && isCLPosAttributePresent(dataPrescription.leftAxis) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftAxis}
                        </td>
                    )}
                </tr>
                <tr>
                    {(isCLPosAttributePresent(dataPrescription.rightColor) || isCLPosAttributePresent(dataPrescription.leftColor)) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_COLOR_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && isCLPosAttributePresent(dataPrescription.rightColor) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightColor}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && isCLPosAttributePresent(dataPrescription.leftColor) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftColor}
                        </td>
                    )}
                </tr>
                <tr>
                    {(isCLPosAttributePresent(dataPrescription.rightAdd) || isCLPosAttributePresent(dataPrescription.leftAdd)) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_ADD_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && isCLPosAttributePresent(dataPrescription.rightAdd) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightAdd}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && isCLPosAttributePresent(dataPrescription.leftAdd) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftAdd}
                        </td>
                    )}
                </tr>
                <tr>
                    {(isCLPosAttributePresent(dataPrescription.rightDominance) || isCLPosAttributePresent(dataPrescription.leftDominance)) && (
                        <td className="secondary-message medium align-left bold">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DOMINANCE_LABEL'
                            )}
                        </td>
                    )}
                    {eyeCode.includes('RIGHT') && isCLPosAttributePresent(dataPrescription.rightDominance) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.rightDominance === 'true' ? 'D' : 'N'}
                        </td>
                    )}
                    {eyeCode.includes('LEFT') && isCLPosAttributePresent(dataPrescription.leftDominance) && (
                        <td className="secondary-message medium align-left">
                            {dataPrescription.leftDominance === 'true' ? 'D' : 'N'}
                        </td>
                    )}
                </tr>
            </tbody>
        </>
    );
};

const renderMobileTable = (
    orderItem: IRetailOrderItems,
    dataPrescription: any,
): JSX.Element => {
    return (
        <div className="contact-table-order-detail">
            <table>
                <thead>
                    <tr>
                        <th>
                        </th>
                        {orderItem.eyeCode.includes('RIGHT') && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_RIGHT_LABEL')}
                            </th>
                        )}
                        {orderItem.eyeCode.includes('LEFT') && (
                            <th className="secondary-message medium align-left bold">
                                {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_DESKTOP_EYE_TYPE_LEFT_LABEL')}
                            </th>
                        )}
                    </tr>
                </thead>

                {renderMobileTableBody(orderItem.eyeCode, dataPrescription)}
            </table>
            <table>
                <tbody>
                    <tr>
                        {(orderItem.eyeCode.includes('RIGHT') || orderItem.eyeCode.includes('LEFT')) && (
                            <td className="secondary-message medium align-left bold">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_BOXES_LABEL'
                                )}
                            </td>
                        )}
                        {orderItem.eyeCode.includes('RIGHT') && (
                            <td className="secondary-message medium align-left quantity">
                                {orderItem.quantityRight}
                            </td>
                        )}
                        {orderItem.eyeCode.includes('LEFT') && (
                            <td className="secondary-message medium align-left quantity">
                                {orderItem.quantityLeft}
                            </td>
                        )}
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

// const sumQuantity = quantity => {
//     let sum = 0;
//     if (typeof quantity === 'string') {
//         return parseInt(quantity);
//     }

//     for (let i = 0; i < quantity.length; i++) {
//         sum += parseInt(quantity[i]);
//     }
//     return sum;
// };

const renderProductImage = (imgUrl, productKind, isPublished) => {
    return (
        <>
            {!!imgUrl && !productKind?.includes('LENSES') && (productKind?.includes('FRAMES') || productKind?.includes('SUN')) && isPublished?.includes('true') && (
                <BoxImage
                    imageUrl={imgUrl}
                    fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
                    imageAlt="Product image"
                />
            )}

            {!!imgUrl && !productKind?.includes('LENSES') && productKind.includes('CONTACTS') && isPublished?.includes('true') && (
                <BoxImage
                    imageUrl={imgUrl}
                    fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
                    imageAlt="Product image"
                />
            )}

            {productKind?.includes('LENSES') && (
                <BoxImage
                    imageUrl={lensImage}
                    fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
                    imageAlt="Product image"
                />
            )}

            {!!imgUrl && (productKind?.includes('ACCESSORIES') || productKind?.includes('APPAREL') || productKind?.includes('OTHER')) && (
                <BoxImage
                    imageUrl={imgUrl}
                    fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
                    imageAlt="Product image"
                />
            )}

            {(!!imgUrl === false || !!isPublished === false || isPublished?.includes('false'))
                && (productKind?.includes('FRAMES') || productKind?.includes('SUN') || productKind?.includes('READERS'))
                && (
                    <div className="placeholder-container-frames">
                        <div className="icon-container">
                            <PlaceHolderFrame />
                        </div>
                        <div className="text-container">
                            <span className='text-container-bold'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_EYEWEAR')}</span>
                            <span className='text-container-standard'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT')}</span>
                        </div>
                    </div>
                )}

            {(!!imgUrl === false || isPublished?.includes('false')) && productKind?.includes('CONTACTS') && (
                <div className="placeholder-container-contact">
                    <div className="icon-container">
                        <PlaceHolderCL />
                    </div>
                    <div className="text-container">
                        <span className='text-container-bold'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_CONTACT')}</span>
                        <span className='text-container-standard'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT')}</span>
                    </div>
                </div>
            )}

            {!!imgUrl === false
                && (productKind?.includes('ACCESSORIES') || productKind?.includes('APPAREL') || productKind?.includes('OTHER'))
                && (
                    <div className="placeholder-container-others">
                        <div className="icon-container">
                            <PlaceHolderOther />
                        </div>
                        <span className='text-container-standard'>{getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_PLACEHOLDER_TEXT')}</span>
                    </div>
                )}
        </>
    );
};

const renderBodyTile = (
    orderItem: IRetailOrderItems,
    isMobile: boolean,
    orderDetailsContactLenses: OrderDetailsContactLenses,
    frameSize: string,
    isOrderItemBuyable: boolean,
    onlyOneIsNotBuyable: boolean,
    isItemContact: boolean
): JSX.Element => {
    const { picture, pdpLink, productKind, hasWarranty, isCustom, isPublished } =
        orderItem;
    return (
        <div className="body">
            {!isOrderItemBuyable && onlyOneIsNotBuyable && isItemContact && (
                <div className="not-buyable-overlay"></div>
            )}
            <div className={
                "product-img retail " +
                ((!!picture === false || !!isPublished === false || isPublished?.includes('false')) ? 'placeholder ' : '') +
                (productKind?.includes('CONTACTS') ? 'contacts ' : '') +
                (productKind?.includes('FRAMES') || productKind?.includes('SUN') ? 'frame ' : '') +
                (productKind?.includes('LENSES') ? 'lenses ' : '')
            }>
                {!!pdpLink ? (
                    <a href={pdpLink}>{renderProductImage(picture, productKind, isPublished)}</a>
                ) : (
                    renderProductImage(picture, productKind, isPublished)
                )}
            </div>
            <div className="body-right">
                {['FRAMES', 'SUN'].includes(productKind) && !!isCustom === false &&
                    renderGlassesBody(orderItem, isMobile, frameSize)}
                {['CONTACTS'].includes(productKind) &&
                    renderContactBody(orderItem, isMobile)}
                {['LENSES'].includes(productKind) && orderItem.isOnlyLens &&
                    renderLensesBody(orderItem, isMobile)}
                {(!(['FRAMES', 'SUN', 'CONTACTS', 'LENSES'].includes(productKind)) || !!isCustom) &&
                    renderOthersBody(orderItem, isMobile)}
                {/* <div className="common-footer">
                    {/* {insuranceBenefits && (
                        <div className="row">
                            <span className="secondary-message align-left success bold medium">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_INSURANCE_BENEFITS_LABEL'
                                )}
                            </span>
                            <span className="secondary-message align-left success large">
                                {insuranceBenefits}
                            </span>
                        </div>
                    )} */}
                {/* CONDITIONS (
                        <div className="row">
                            <span
                                className={`secondary-message align-left success bold ${
                                    isMobile ? 'small' : 'medium'
                                }`}
                            >
                                {getLabelFallback(
                                    'INFORMATION'
                                )}
                            </span>
                            <span className="secondary-message align-left success large">
                                VALUE
                            </span>
                        </div>
                    )
                </div> */}
            </div>
        </div>
    );
};

const HorizontalTileRetail = ({ orderItem, orderId, storeNumber, prescriptionInfo, onlyOneIsNotBuyable, isTrackItem, hasPrescriptionId }: Props) => {
    const dispatch = useDispatch();

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const encodedOrderId = useSelector((state: RootState) => state.myPurchases.encodedOrderId);
    const orderItemCarrierUrl = useSelector(
        (state: RootState) => state.myPurchases.orderItemCarrierUrl
    );
    const [modalPreview, setModalPreview] = useState(false);
    const prescriptionInfoDetails = useSelector(
        (state: RootState) => state.myPurchases.prescriptionInfoDetails
    );
    const personalDetails = useSelector((state: RootState) => state.myProfile.personalDetails);
    const [prescriptionFile, setPrescriptionFile] = useState(null);
    const [prescriptionDoctor, setPrescriptionDoctor] = useState(null);
    const [prescriptionManual, setPrescriptionManual] = useState(null);
    const [prescriptionFileName, setPrescriptionFileName] = useState(null);
    const [errorImg, setErrorImg] = useState(null);

    const [orderDetailsContactLenses, setOrderDetailsContactLenses] =
        useState<OrderDetailsContactLenses>(null);

    const openPreview = () => {
        const prescriptionDetails = prescriptionInfo;
        if (!!prescriptionDetails && Object.keys(prescriptionDetails).length > 0) {
            setPrescriptionManual({
                sph_od: prescriptionDetails.rightSphere,
                sph_os: prescriptionDetails.leftSphere,
                cyl_od: prescriptionDetails.rightCyl,
                cyl_os: prescriptionDetails.leftCyl,
                ax_od: prescriptionDetails.rightAxis,
                ax_os: prescriptionDetails.leftAxis,
                pupillaryDistance: prescriptionDetails.pupillaryDistance,
                pupillaryDistance_left: prescriptionDetails.pupillaryDistance_left,
                add_od: prescriptionDetails.rightAdd,
                add_os: prescriptionDetails.leftAdd,
                color_od: prescriptionDetails.rightColor,
                color_os: prescriptionDetails.leftColor,
                prism_enabled: prescriptionDetails.prismEnable.includes('true'),
                vprism_os: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.osVPrism
                    : null,
                vprism_base_os: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.osVPrismBaseDir
                    : null,
                vprism_od: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.odVPrism
                    : null,
                vprism_base_od: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.odVPrismBaseDir
                    : null,
                hprism_os: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.osHPrism
                    : null,
                hprism_base_os: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.osHPrismBaseDir
                    : null,
                hprism_od: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.odHPrism
                    : null,
                hprism_base_od: prescriptionDetails.prismEnable.includes('true')
                    ? prescriptionDetails.odHPrismBaseDir
                    : null,
            });

            setModalPreview(true);
        }
    };

    const renderCompletePrescription = (): JSX.Element => {
        return (
            <div className="prescription">
                <div className="left">
                    <div className={'info-icon retail ' + (!isItemContact && !isOnlyLenses && !!prescriptionInfo && Object.keys(prescriptionInfo).length > 0 ? 'prescriptionAvailable' : '')}>
                        <CheckPrescription />
                    </div>
                    <div className="info-message">
                        <div className={'primary-message bold align-left dark-info prescription-submitted'}>
                            {getLabelFallback(
                                'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_TITLE'
                            )}
                        </div>
                        {!isMobile && (
                            <>
                                <div className={'primary-message bold align-left dark-info prescription-submitted subtitle'}>
                                    {getLabelFallback(
                                        'MYPURCHASES__RETAIL_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_SUBTITLE'
                                    )}
                                </div>
                            </>
                        )}
                        <div className={'secondary-message align-left dark-info'}>
                            {getLabelFallback(
                                'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_MESSAGE_SUBTITLE'
                            )}
                        </div>
                    </div>
                </div>
                <a
                    className={'secondary-message dark-info bold preview' + (!isItemContact && !isOnlyLenses && !!prescriptionInfo && Object.keys(prescriptionInfo).length > 0 ? '' : ' hide')}
                    onClick={() => {
                        openPreview();
                    }}
                >
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_PRESCRIPTION_PREVIEW'
                    )}
                </a>
            </div>
        );
    };

    const renderModalPreview = (): JSX.Element => {
        return (
            <Modal isOpen={modalPreview} close={() => setModalPreview(false)}>
                <PrescriptionModal
                    prescriptionFile={prescriptionFile}
                    prescriptionDoctor={prescriptionDoctor}
                    prescriptionManual={prescriptionManual}
                    errorImgInner={errorImg}
                    prescriptionFileName={prescriptionFileName}
                />
            </Modal>
        );
    };

    useEffect(() => {
        dispatch(getPersonalDetails(config.mockRequest, config.storeId));
    }, []);

    const handleClickTrackMyOrderItem = () => {
        const email = getCookie('email_address');
        const lastName = personalDetails.lastname

        dispatch(getTrackThisItemInfo(config.isMockRequest, config.storeId, orderId, email, lastName))
    }


    const renderShippedHeaderTile = (
        statusOrderItem: string,
        storeNumber: string,
        buyable: boolean,
        onlyOneIsNotBuyable: boolean,
        isItemContact: boolean
    ): JSX.Element => {
        const isNotBuyableShowable = !buyable && onlyOneIsNotBuyable && isItemContact && (statusOrderItem.toLowerCase() === 'delivered' || statusOrderItem.toLowerCase() === 'dispensed') ? true : false
        return (
            <>
                {!isNotBuyableShowable && (
                    <div className="header">
                        <div className="left">
                            <div className="label">
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_STATUS_LABEL'
                                )}
                            </div>
                            <div className="value">
                                {getLabelFallback(
                                    statusOrderItem.toLowerCase().includes('order receive')
                                        ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_ORDER_RECEIVE'
                                        : statusOrderItem.toLowerCase() === 'in process'
                                            ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_IN_PROCESS'
                                            : statusOrderItem.toLowerCase() === 'shipped'
                                                ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                                : statusOrderItem.toLowerCase() === 'ready for pickup'
                                                    ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                                    : statusOrderItem.toLowerCase() === 'dispensed'
                                                        ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                                        : statusOrderItem.toLowerCase() === 'please call the store'
                                                            ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_PLEASE_CALL_THE_STORE'
                                                            : statusOrderItem.toLowerCase() === 'delivered'
                                                                ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_SHIPPED'
                                                                : statusOrderItem.toLowerCase() === 'returned'
                                                                    ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_RETURNED'
                                                                    : statusOrderItem.toLowerCase() === 'in progress'
                                                                        ? 'MYPURCHASES_RETAIL_ORDERS_ORDER_STATUS_IN_PROCESS'
                                                                        : ''
                                ).replace("${storeNumber}", storeNumber)}
                            </div>
                        </div>
                        {statusOrderItem.toLowerCase() != 'returned' && isTrackItem && (
                            <button
                                className="primary-button button-size-small custom-mob"
                                data-element-id="OrderDetails_TrackMyOrder"
                                onClick={() => handleClickTrackMyOrderItem()}
                            >
                                {getLabelFallback(
                                    'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_TRACK_THIS_ITEM_CTA_LABEL'
                                )}
                            </button>
                        )}
                    </div>
                )}
                {isNotBuyableShowable && (
                    <div className="header">
                        <div className="left">
                            <div className="not-buyable-icon">
                                <InfoIcon />
                            </div>
                            <span className="not-buyable-text"
                                dangerouslySetInnerHTML={{
                                    __html: getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_HORIZONTAL_TILE_NOT_BUYABLE_LABEL'),
                                }}
                            ></span>
                        </div>
                    </div>
                )}
            </>
        );
    };

    const isOrderItemBuyable = !!orderItem.buyable && orderItem.buyable.toLowerCase() === 'true' ? true : false
    const isOnlyLenses = orderItem.productKind === "LENSES"
    const isItemFrameOrSun = orderItem.productKind === "FRAMES" || orderItem.productKind === "SUN"
    const isItemContact = orderItem.productKind === "CONTACTS"

    return (
        <div className={`horizontal-tile retail ${onlyOneIsNotBuyable && !isOrderItemBuyable && isItemContact && (orderItem.orderItemStatus.toLowerCase() === 'delivered' || orderItem.orderItemStatus.toLowerCase() === 'dispensed') ? 'not-buyable' : ''}`}>
            {renderShippedHeaderTile(
                orderItem.orderItemStatus.toLowerCase(),
                storeNumber,
                isOrderItemBuyable,
                onlyOneIsNotBuyable,
                isItemContact
            )}
            {!!hasPrescriptionId && hasPrescriptionId.length > 0 && (isItemFrameOrSun || isOnlyLenses || (isItemContact && isOrderItemBuyable)) && (
                renderCompletePrescription()
            )}
            {/* CAPIRE SE HA UNA PRESCRIZIONE */}
            {(!!prescriptionFile || !!prescriptionDoctor || !!prescriptionManual) &&
                renderModalPreview()}
            {renderBodyTile(orderItem, isMobile, orderDetailsContactLenses, orderItem.frameSize, isOrderItemBuyable, onlyOneIsNotBuyable, isItemContact)}
        </div>
    );
};
export default HorizontalTileRetail;
